import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked, faBug, faSeedling } from '@fortawesome/free-solid-svg-icons';
import api from '../api/client';

const ROWS = [
  { key: 'inStock', icon: faBoxesStacked, label: 'Seeds in Stock', accent: '#15803d', bg: '#f0fdf4' },
  { key: 'underTreatment', icon: faBug, label: 'Seeds Under Treatment', accent: '#b45309', bg: '#fffbeb' },
  { key: 'underGermination', icon: faSeedling, label: 'Seeds Under Germination', accent: '#0369a1', bg: '#f0f9ff' },
];

function SeedsStatusTotals({ onTotalClick }) {
  const [totals, setTotals] = useState({
    inStock: 0,
    underTreatment: 0,
    underGermination: 0,
  });

  useEffect(() => {
    api.get('/api/seeds_totals')
      .then(response => response.data)
      .then(data => setTotals(data))
      .catch(error => console.error('Error fetching totals:', error));
  }, []);

  return (
    <div className="seeds-statuses-report-totals">
      {ROWS.map(row => (
        <div
          key={row.key}
          className="seeds-statuses-report-row"
          onClick={() => onTotalClick(row.key)}
        >
          <span
            className="seeds-statuses-report-row-icon"
            style={{ backgroundColor: row.bg, color: row.accent }}
          >
            <FontAwesomeIcon icon={row.icon} />
          </span>
          <span className="seeds-statuses-report-row-label">{row.label}</span>
          <span className="seeds-statuses-report-row-value">
            {Number(totals[row.key]).toLocaleString()} lbs
          </span>
        </div>
      ))}
    </div>
  );
}

export default SeedsStatusTotals;
